import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromSvcVehicleDiagnosticsRoot from './+state/svc-vehicle-diagnostics-root.reducer';
import { SvcVehicleDiagnosticsRootEffects } from './+state/svc-vehicle-diagnostics-root.effects';
import { SvcVehicleDiagnosticsRootFacade } from './+state/svc-vehicle-diagnostics-root.facade';
import {
  WorkOrdersEntityModule,
} from '@quorum/sha-entities/fixed-operations';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromSvcVehicleDiagnosticsRoot.SVC_VEHICLE_DIAGNOSTICS_ROOT_FEATURE_KEY,
      fromSvcVehicleDiagnosticsRoot.reducer
    ),
    WorkOrdersEntityModule,
    EffectsModule.forFeature([SvcVehicleDiagnosticsRootEffects]),
  ],
  providers: [SvcVehicleDiagnosticsRootFacade],
})
export class SvcVehicleDiagnosticsRootModule {}
